export default "__VITE_ASSET__f7abadd2__$_?nuxt_component=async__"